import { SagaIterator } from 'redux-saga';
import { PASSWORD_RESET_TOKEN } from 'src/modules/password-reset/actions/PasswordResetActions';
import { put } from 'typed-redux-saga';

export function* resetPasswordResetToken(): SagaIterator<void> {
  yield* put(PASSWORD_RESET_TOKEN.trigger(null));
}
